export default __webpack_public_path__ + "static/media/divider-yellow.a4d11326.svg";